import LegalDocument from "../components/LegalDocument";
import dmcaContent from "../content/dmca";

export default function DMCA() {
  return <LegalDocument pageTitle="DMCA" content={dmcaContent} />;
}
